import { List, Typography } from '@mui/material';
import Iconify from 'src/components/iconify';
import { SkeletonConversationItem } from 'src/components/skeleton';
import {
  NavAccordionDetails,
  NavAccordionLabel,
  NavAccordionSummary,
} from 'src/features/Navbar/NavAccordion/NavAccordion';
import { NavAccordionPersisted } from 'src/features/Navbar/NavAccordionPersisted';
import { NavActionButton } from 'src/features/Navbar/NavActionButton/NavActionButton';
import { useLocales } from 'src/locales';
import { useCreateTodoModal } from 'src/pages/dashboard/TodosPage/CreateTodoModal';
import { TodoNavItem } from 'src/pages/dashboard/TodosPage/shared/TodoNavItem/TodoNavItem';
import { useTodoListQuery } from 'src/pages/dashboard/TodosPage/shared/useTodoListQuery';
import { UIFeature } from 'src/state/ui/types';
import { MoreNavItensButton } from '../../shared/MoreNavItensButton';
import { useTodoNavMoreDrawer } from './TodoNavMoreDrawer';

export const TodosNav = () => {
  const { todoList, isTodosLoading, ordersList } = useTodoListQuery();
  const { showTodoCreateModal } = useCreateTodoModal();
  const { translate } = useLocales();

  const { showTodoNavMoreDrawer } = useTodoNavMoreDrawer();
  const handleCreateTodoList = (e: any) => {
    e.stopPropagation();
    showTodoCreateModal({
      orders: ordersList,
      position: ordersList.length,
      tags: [],
      defaultTodoList: '',
    });
  };

  return (
    <NavAccordionPersisted feature={UIFeature.todos}>
      <NavAccordionSummary className="todos">
        <NavAccordionLabel>
          <Iconify className="navIcon" icon="tabler:circle-check-filled" />
          <Typography variant="subtitle2" whiteSpace="nowrap">
            {translate('header.nav_vertical.board_tab.todo')}
          </Typography>
        </NavAccordionLabel>
        <NavActionButton icon="tabler:plus" onClick={handleCreateTodoList} />
      </NavAccordionSummary>
      <NavAccordionDetails>
        {isTodosLoading && (
          <List disablePadding>
            <SkeletonConversationItem />
            <SkeletonConversationItem />
            <SkeletonConversationItem />
            <SkeletonConversationItem />
            <SkeletonConversationItem />
          </List>
        )}
        {!isTodosLoading && todoList && (
          <List disablePadding>
            {todoList.map((todo) => (
              <TodoNavItem key={todo._id} todo={todo} />
            ))}
            {todoList.length > 8 && (
              <MoreNavItensButton onClick={showTodoNavMoreDrawer} />
            )}
          </List>
        )}
      </NavAccordionDetails>
    </NavAccordionPersisted>
  );
};
